import script from "./LocationCouplingPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocationCouplingPopup.vue?vue&type=script&setup=true&lang=ts"

import "./LocationCouplingPopup.vue?vue&type=style&index=0&id=c33adfc8&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c33adfc8"]])

export default __exports__